import { forEach, remove } from 'lodash'
import { produce } from 'immer'
import { LicensePlateData } from '../apis/licensePlate.api'
import { ContactSiteData } from '../apis/contactSite.api'
import { ActionName } from '../components/Actions'
import { TableHorizontalData } from '../components/TableHorizontal'

export default {
  tableHorizontalData (licensePlates: LicensePlateData[])
    : TableHorizontalData<LicensePlateData>[] {
    forEach(
      licensePlates,
      (licensePlate: TableHorizontalData<LicensePlateData>) => {
        const actions: ActionName[] = ['download']
        if (!licensePlate.isDeleted) actions.push('delete')
        licensePlate.actions = actions
        // Bind customer and customerSite
        if (licensePlate.applicable) {
          const { applicableType, applicable } = licensePlate
          let customer = null
          let customerSite = null
          if (applicableType === 'customer') {
            customer = applicable
          } else if (applicableType === 'customerSite') {
            customerSite = applicable
            const { contact } = (applicable as ContactSiteData)
            if (!contact || !contact.contactable) return
            customer = contact.contactable
          }
          licensePlate.customer = customer
          licensePlate.customerSite = customerSite
        }
      })
    return licensePlates
  },

  delete (metas: TableHorizontalData<LicensePlateData>[], id: number) {
    return produce(metas, metas => {
      remove(metas, { id })
    })
  }
}
